// extracted by mini-css-extract-plugin
module.exports = {"module":"PromoCodeForm_module__qZlm2","inner":"PromoCodeForm_inner__1Bt0x","submitButton":"PromoCodeForm_submitButton__3Swq0"};